<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <!--    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex ">-->
    <!--      <div class="d-none d-sm-block col-8" />-->
    <!--      <router-link-->
    <!--        to="/planoupgrade"-->
    <!--      >-->
    <!--        <b-button-->
    <!--            v-if="verificaPlano === 1"-->
    <!--          v-ripple.400="'rgba(40, 199, 111, 0.15)'"-->
    <!--          variant="success"-->
    <!--          pill-->
    <!--          size="lg"-->
    <!--        >-->
    <!--          {{plano}} gratis por 30 dias!-->
    <!--        </b-button>-->
    <!--      </router-link>-->
    <!--    </div>-->
    <MensagemVerifica v-if="userData.user_ativo === 0" />

    <!-- <div  class="card text-center bg-danger m-1" style="height:70%"> <h4 style="color:white;">Sua assinatura está expirada, por favor regularize para ter acesso as ferramentas!</h4></div> -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <notification-dropdown />
      <upload-videos v-if="this.$route.path === '/Videos'" />
      <!-- <editar/> -->
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.user_name }}
              {{ userData.user_sobrenome }}
            </p>
            <span
              v-show="userData.user_role === 'admin'"
              class="user-status"
            >{{ userData.user_role }}</span>

          </div>

          <b-avatar
            :src="userData.user_photo_url"
            size="40"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-divider />
        <b-dropdown-item link-class="d-flex align-items-center">
          <router-link :to="'/perfil'">
            <feather-icon
              size="16"
              icon="UserIcon"
              class="mr-50"
            />
            <span>Perfil</span>
          </router-link>

          <!-- <router-link to="" >
            <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
         </router-link> -->

        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>

      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadVideos from '@/components/uploadVideos.vue'
import MensagemVerifica from '@/components/MensagemVerifica.vue'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import NotificationDropdown from '@/layouts/components/NotificationDropdown.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // Navbar Components
    BButton,
    UploadVideos,
    MensagemVerifica,
    NotificationDropdown,
  },
  directives: {
    Ripple,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      userData: JSON.parse(localStorage.getItem('userData')),
      plano: '',
      verificaPlano: '',
      authenticated: false,
      rotaAtiva: '',
      mockAccount: {
        password: '',
        userEmail: '',

      },

    }
  },
  watch: {
    $route(to, from) {
      this.rotaAtiva = to.path
    },
  },

  mounted() {
    this.buscarDados()
    if (!this.authenticated) {

      // this.$router.replace({name: ""});
    }
    setInterval(() => {
      this.LeLocal()
    }, 5000)

    this.$store.commit('User/setUser', JSON.parse(localStorage.getItem('userData')))
  },
  methods: {
    retornarUserAdmin() {
      this.$store.dispatch('User/loginUserClientAdminDKP', {
        ...JSON.parse(localStorage.getItem('lgn_admin_metadata')),
      })
      localStorage.removeItem('lgn_admin_metadata')
      this.$router.replace('/')
    },
    buscarDados() {
      const options = { method: 'GET' }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.userData.id}`, options)
        .then(response => response.json())
        .then(response => {
          this.plano = response[0].planocontratado === 'VSL Booster' ? 'CHAT Booster' : 'VSL Booster'
          this.verificaPlano = response.length
        })
        .catch(err => console.error(err))
    },
    LeLocal() {
      this.userData = JSON.parse(localStorage.getItem('userData'))
    },
    setAuthenticated(status) {
      this.authenticated = status
    },
    logout() {
      const newUserData = JSON.parse(localStorage.getItem('userData'))
      this.$store.commit('User/setUsuarioDeslogado', false)
      if (this.userData.id === 704641 || this.userData.dono_aluno === 704641) {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        localStorage.removeItem('lgn_admin')
        localStorage.removeItem('lgn_admin_metadata')
        this.$ability.update(initialAbility)
        this.$forceUpdate()
        this.$router.push({ name: 'auth-login-brc' })
      } else {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        localStorage.removeItem('lgn_admin')
        localStorage.removeItem('lgn_admin_metadata')
        this.$ability.update(initialAbility)
        this.$forceUpdate()
        this.$router.push({ name: 'auth-login' })
      }
    },

  },
}
</script>
